import { useCallback } from 'react';
import SettingsForm from '../../../components/SettingsForm';
import { getStoreEmailSettings, saveStoreEmailSettings } from '../../../utils/queries';
import { useCan } from '../../../hooks/useCan';
import { PLATFORMADMIN_ROLES } from '../../../components/navConfig';

export default function EmailSenderTab({ storeId }) {
	const canEdit = useCan(PLATFORMADMIN_ROLES);
	const load = useCallback(() => getStoreEmailSettings(storeId), [storeId]);
	const save = useCallback((fields) => saveStoreEmailSettings(storeId, fields), [storeId]);

	const fields = [
		{ key: 'fromName', label: 'From Name' },
		{ key: 'fromEmail', label: 'From Email' },
		{ key: 'replyToEmail', label: 'Reply-To Email' },
	];

	return (
		<SettingsForm
			load={load}
			save={save}
			fields={fields}
			emptyMessage='No sender settings yet - falls back to the account-wide SendGrid defaults until saved.'
			canEdit={canEdit}
		/>
	);
}
